import * as React from "react";

import cloud from './imgs/cloudly/cloud.png'
import cRain from './imgs/cloudly/cloud1.png'
import cElectricStorm from './imgs/cloudly/cloud3.png'
import cSnow from './imgs/cloudly/cloud2.png'
import cWind from './imgs/cloudly/cloud4.png'
import cBroken from './imgs/cloudly/cloud5.png'

import sun from './imgs/day/sun.png'
import sCloud from './imgs/day/sun1.png'
import sRain from './imgs/day/sun2.png'
import sSnow from './imgs/day/sun3.png'
import sElectricStorm from './imgs/day/sun4.png'
import sWind from './imgs/day/sun5.png'
import sShowerRain from './imgs/day/sun6.png'

import moon from './imgs/night/moon.png'
import mCloud from './imgs/night/moon1.png'
import mRain from './imgs/night/moon2.png'
import mSnow from './imgs/night/moon3.png'
import mElectricStorm from './imgs/night/moon4.png'
import mWind from './imgs/night/moon5.png'
import mShowerRain from './imgs/night/moon6.png'





function IconSquareGithub(props) {
    return (
        <svg
            viewBox="0 0 448 512"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z" />
        </svg>
    );
}

function IconWiThermometer(props) {
    return (
        <svg
            viewBox="3 2 23 23"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M9.91 19.56a5.101 5.101 0 012.24-4.22V5.42c0-.8.27-1.48.82-2.03s1.23-.84 2.03-.84c.81 0 1.49.28 2.04.83.55.56.83 1.23.83 2.03v9.92c.71.49 1.25 1.11 1.64 1.84s.58 1.53.58 2.38c0 .92-.23 1.78-.68 2.56s-1.07 1.4-1.85 1.85-1.63.68-2.56.68c-.92 0-1.77-.23-2.55-.68s-1.4-1.07-1.86-1.85-.68-1.63-.68-2.55zm1.76 0c0 .93.33 1.73.98 2.39.65.66 1.44.99 2.36.99.93 0 1.73-.33 2.4-1s1.01-1.46 1.01-2.37c0-.62-.16-1.2-.48-1.73-.32-.53-.76-.94-1.32-1.23l-.28-.14c-.1-.04-.15-.14-.15-.29V5.42c0-.32-.11-.59-.34-.81-.23-.21-.51-.32-.85-.32-.32 0-.6.11-.83.32-.23.21-.34.48-.34.81v10.74c0 .15-.05.25-.14.29l-.27.14c-.55.29-.98.7-1.29 1.23-.31.53-.46 1.1-.46 1.74zm.78 0c0 .71.24 1.32.73 1.82s1.07.75 1.76.75 1.28-.25 1.79-.75.76-1.11.76-1.81c0-.63-.22-1.19-.65-1.67-.43-.48-.96-.77-1.58-.85V9.69c0-.06-.03-.13-.1-.19a.299.299 0 00-.22-.1c-.09 0-.16.03-.21.08-.05.06-.08.12-.08.21v7.34c-.61.09-1.13.37-1.56.85-.43.49-.64 1.04-.64 1.68z" />
        </svg>
    );
}

function IconWiRaindrop(props) {
    return (
        <svg
            viewBox="8 7 14 14"
            fill="currentColor"
            {...props}
        >
            <path d="M9.81 15.25c0 .92.23 1.78.7 2.57s1.1 1.43 1.9 1.9c.8.47 1.66.71 2.59.71.93 0 1.8-.24 2.61-.71a5.3 5.3 0 001.92-1.9c.47-.8.71-1.65.71-2.57 0-.6-.17-1.31-.52-2.14-.35-.83-.77-1.6-1.26-2.3-.44-.57-.96-1.2-1.56-1.88-.6-.68-1.65-1.73-1.89-1.97l-1.28 1.29c-.62.6-1.22 1.29-1.79 2.08-.57.79-1.07 1.64-1.49 2.55-.44.91-.64 1.7-.64 2.37z" />
        </svg>
    );
}

function IconWind(props) {
    return (
        <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            viewBox="0 0 24 24"
            height="1em"
            width="1em"
            {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" />
            <path d="M5 8h8.5a2.5 2.5 0 10-2.34-3.24M3 12h15.5a2.5 2.5 0 11-2.34 3.24M4 16h5.5a2.5 2.5 0 11-2.34 3.24" />
        </svg>
    );
}

function IconEyeFill(props) {
    return (
        <svg
            fill="currentColor"
            viewBox="0 0 16 16"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M10.5 8a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" />
        </svg>
    );
}

function IconWiHot(props) {
    return (
        <svg
            viewBox="3 2 23 23"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M4.14 14.76c0-.24.09-.44.27-.61.17-.17.38-.25.62-.25h2.06c.24 0 .44.08.6.25.17.17.25.37.25.61 0 .25-.08.46-.25.63-.17.17-.37.25-.6.25H5.03c-.25 0-.46-.08-.63-.25a.823.823 0 01-.26-.63zm2.92-7.02c0-.23.08-.44.24-.62.2-.16.41-.25.66-.25.21 0 .41.08.59.25L10 8.6c.17.16.25.36.25.6s-.08.44-.25.6a.8.8 0 01-.6.25c-.26 0-.46-.08-.61-.25l-1.5-1.44a.966.966 0 01-.23-.62zm2.61 7.02c0-.71.14-1.39.43-2.04.28-.65.67-1.22 1.14-1.69.48-.47 1.05-.85 1.7-1.13s1.34-.43 2.06-.43c.96 0 1.84.24 2.66.72.82.48 1.47 1.12 1.94 1.94.47.81.71 1.69.71 2.63 0 .15-.01.29-.03.42-.28-.17-.6-.25-.97-.25-.24 0-.48.05-.72.15.01-.07.01-.18.01-.32 0-.98-.35-1.81-1.06-2.5-.71-.69-1.56-1.04-2.55-1.04-.99 0-1.83.35-2.54 1.04s-1.05 1.52-1.05 2.5v.18c-.29.02-.57.1-.84.25-.01.01-.04.03-.1.07s-.12.09-.19.14-.14.11-.23.19-.18.16-.26.24c-.08-.32-.11-.68-.11-1.07zm.03 3.65v-.15c-.01-.09 0-.2.02-.33.05-.36.19-.7.42-1.02.13-.16.22-.27.27-.31a.21.21 0 01.04-.06l.04-.04a.44.44 0 00.12-.1l.08-.08c.03-.03.06-.04.07-.06.05-.05.1-.08.14-.1l.17-.11c.14-.09.31-.14.5-.14h.03c.1 0 .19.01.26.03.03.01.07.03.13.07v.01a.798.798 0 01.47.71c0 .17-.05.31-.14.42-.06.09-.14.17-.22.23l-.06.03-.04.02-.06.04c-.04.03-.07.06-.1.08s-.06.06-.11.11c-.04.05-.08.09-.11.14-.03.04-.06.1-.09.15-.03.06-.05.12-.05.17v.15c.04.15.08.27.11.36.07.14.18.28.34.44.01.02.09.1.24.25.86.78 1.27 1.62 1.21 2.5-.02.3-.09.59-.21.87s-.26.51-.43.7c-.16.19-.29.33-.39.43-.1.09-.18.16-.25.21-.01.01-.03.02-.06.04s-.06.04-.07.04c-.08.04-.15.06-.22.07-.09.01-.15.02-.2.02-.3 0-.54-.1-.71-.3a.788.788 0 01-.18-.59c.02-.22.13-.4.33-.53l.01-.03c.01-.01.03-.03.05-.04.02-.02.04-.04.07-.06.03-.02.06-.05.08-.08a.7.7 0 00.08-.1c.03-.04.06-.08.08-.12.03-.04.06-.09.08-.14.03-.05.05-.1.07-.15.02-.05.03-.1.05-.16.01-.06.02-.12.02-.17.02-.2-.03-.4-.15-.6-.05-.11-.12-.22-.22-.33-.07-.08-.12-.13-.15-.16-.09-.11-.14-.17-.15-.18-.02-.01-.04-.03-.07-.06s-.05-.04-.06-.05c-.15-.14-.26-.26-.34-.36-.12-.16-.21-.26-.24-.32-.19-.26-.32-.52-.39-.78-.04-.14-.07-.25-.08-.32 0-.02-.01-.05-.02-.08s-.01-.05-.01-.08zm3.88-.33c0-.06 0-.1.01-.14.02-.22.09-.43.2-.64.11-.21.22-.39.35-.53.13-.14.25-.27.38-.38s.23-.19.31-.25l.12-.07c.15-.09.32-.14.5-.14.11 0 .21.01.3.03.01 0 .02.01.05.02.03.02.05.03.06.04.01 0 .02 0 .03.01.01 0 .03.02.07.05.2.12.32.3.38.54V16.74c0 .03-.01.07-.02.12s-.02.08-.02.09c-.07.23-.21.39-.42.5-.33.22-.51.45-.53.69a.81.81 0 000 .22c.02.12.08.25.17.39.11.16.19.27.24.32.16.16.25.25.28.27.12.11.28.28.47.51.54.65.79 1.32.74 2-.02.3-.09.59-.21.87s-.26.51-.43.7c-.16.18-.3.33-.4.43-.11.1-.19.17-.25.21l-.12.08c-.11.04-.17.06-.21.07-.11.01-.18.02-.2.02h-.03a.92.92 0 01-.19-.02c-.02 0-.05 0-.08-.01s-.06-.01-.07-.01c-.01 0-.02 0-.03-.01-.01-.01-.02-.01-.04-.02-.01-.01-.02-.01-.03-.01-.15-.11-.24-.17-.26-.21a.744.744 0 01.15-1.13l.03-.04c.02-.02.05-.05.09-.08l.12-.12.13-.16.12-.19.09-.22.04-.24c.01-.4-.22-.82-.69-1.27-.19-.17-.33-.31-.44-.43-.55-.69-.8-1.34-.76-1.98zm.54-11.16V4.85c0-.24.09-.45.26-.62.17-.17.38-.25.61-.25.24 0 .45.08.62.25.17.17.25.38.25.62v2.07c0 .24-.08.43-.25.59s-.37.23-.61.23a.89.89 0 01-.61-.23.75.75 0 01-.27-.59zm3.36 11.01c.02-.22.09-.43.2-.64.11-.21.22-.39.35-.53.13-.14.25-.27.38-.38.12-.11.22-.19.3-.25l.13-.07c.02-.02.06-.04.1-.08.11-.04.24-.07.38-.07.34 0 .59.13.77.38.05.07.08.14.1.23.01.02.02.05.02.08v.11c0 .31-.15.55-.45.7-.32.21-.49.44-.52.69-.04.34.19.74.68 1.2.88.77 1.28 1.61 1.23 2.5-.02.3-.09.59-.21.87s-.27.51-.43.7c-.17.19-.3.33-.39.43s-.18.16-.25.21c-.16.1-.3.15-.41.16-.03.01-.08.01-.15.01-.3 0-.53-.1-.69-.3-.15-.17-.21-.37-.19-.59s.13-.4.32-.53c.03-.01.09-.06.18-.14s.18-.21.29-.38c.1-.18.16-.35.17-.53.02-.4-.22-.82-.7-1.27-.41-.36-.73-.75-.94-1.16-.24-.42-.33-.88-.27-1.35zm2.29-8.72c0-.25.08-.45.23-.6l1.46-1.48c.18-.17.38-.25.61-.25.24 0 .44.09.61.26s.26.38.26.61c0 .25-.09.46-.26.62L21.2 9.81c-.18.17-.38.25-.61.25-.23 0-.43-.08-.58-.25a.83.83 0 01-.24-.6zm2.3 5.55c0-.22.09-.42.26-.61.16-.17.35-.25.58-.25h2.06c.24 0 .45.09.62.26s.27.37.27.6c0 .24-.09.45-.26.62-.18.17-.38.26-.63.26h-2.06a.77.77 0 01-.6-.25.884.884 0 01-.24-.63z" />
        </svg>
    );
}

function IconSpeedometer(props) {
    return (
        <svg
            viewBox="0 0 512 512"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M425.7 118.25A240 240 0 0076.32 447l.18.2c.33.35.64.71 1 1.05.74.84 1.58 1.79 2.57 2.78a41.17 41.17 0 0060.36-.42 157.13 157.13 0 01231.26 0 41.18 41.18 0 0060.65.06l3.21-3.5.18-.2a239.93 239.93 0 00-10-328.76zM240 128a16 16 0 0132 0v32a16 16 0 01-32 0zM128 304H96a16 16 0 010-32h32a16 16 0 010 32zm48.8-95.2a16 16 0 01-22.62 0l-22.63-22.62a16 16 0 0122.63-22.63l22.62 22.63a16 16 0 010 22.62zm149.3 23.1l-47.5 75.5a31 31 0 01-7 7 30.11 30.11 0 01-35-49l75.5-47.5a10.23 10.23 0 0111.7 0 10.06 10.06 0 012.3 14zm31.72-23.1a16 16 0 01-22.62-22.62l22.62-22.63a16 16 0 0122.63 22.63zm65.88 227.6zM416 304h-32a16 16 0 010-32h32a16 16 0 010 32z" />
        </svg>
    );
}

function IconSearch(props) {
    return (
        <svg
            viewBox="0 0 512 512"
            fill="white"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z" />
        </svg>
    );
}

function IconWiSunrise(props) {
    return (
        <svg
            viewBox="0 0 30 30"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M2.75 15.36c0-.25.1-.48.3-.69.22-.19.46-.29.7-.29h2.33c.27 0 .49.1.67.29.18.19.27.43.27.69 0 .29-.09.53-.27.72a.9.9 0 01-.67.29H3.75c-.27 0-.5-.1-.7-.3-.2-.21-.3-.45-.3-.71zm3.33-7.98c0-.27.09-.5.26-.68.23-.2.46-.3.71-.3.26 0 .49.1.68.29l1.64 1.65c.19.22.28.45.28.69 0 .28-.09.52-.27.7s-.4.28-.66.28c-.24 0-.48-.1-.7-.29L6.34 8.11c-.17-.21-.26-.46-.26-.73zm2 13.5c0-.28.1-.51.29-.68.18-.17.4-.26.68-.26h2.63l3.11-2.92c.1-.08.21-.08.34 0l3.16 2.92h2.77c.27 0 .5.09.69.28a.9.9 0 01.29.67c0 .27-.1.5-.29.69-.19.19-.42.29-.69.29h-3.38c-.1 0-.2-.02-.29-.07l-2.41-2.27-2.39 2.27c-.08.05-.17.07-.28.07H9.05a.974.974 0 01-.97-.99zM9 15.36c0 .97.21 1.85.62 2.64.02.12.11.18.25.18h1.88c.07 0 .12-.03.15-.08.03-.06.02-.12-.02-.19-.64-.77-.96-1.62-.96-2.55 0-1.12.4-2.08 1.2-2.87.8-.79 1.76-1.18 2.89-1.18 1.12 0 2.07.39 2.86 1.18.79.79 1.19 1.74 1.19 2.87 0 .94-.32 1.79-.95 2.55-.04.07-.05.13-.03.19s.07.08.15.08h1.9c.13 0 .21-.06.23-.18.44-.77.64-1.65.64-2.64 0-.81-.16-1.59-.48-2.32-.32-.74-.75-1.37-1.28-1.91a6.1 6.1 0 00-1.91-1.28c-.74-.32-1.51-.47-2.32-.47-.81 0-1.59.16-2.33.47-.74.32-1.38.74-1.92 1.28A5.96 5.96 0 009 15.36zm5.03-8.96V4.1c0-.29.09-.52.28-.71s.43-.28.71-.28c.28 0 .51.09.7.28s.28.44.28.72v2.3c0 .29-.09.52-.28.71-.18.18-.42.28-.7.28a.95.95 0 01-.71-.28.972.972 0 01-.28-.72zm6.35 2.64c0-.25.09-.48.27-.69l1.62-1.65c.19-.19.43-.29.7-.29.27 0 .51.1.69.29.19.19.28.42.28.69 0 .29-.09.53-.26.73L22 9.73c-.21.19-.45.29-.7.29-.27 0-.49-.09-.66-.28s-.26-.42-.26-.7zm2.61 6.32c0-.27.09-.5.27-.69.18-.19.4-.29.66-.29h2.35c.27 0 .5.1.69.29a.99.99 0 010 1.4c-.19.2-.42.3-.69.3h-2.35c-.27 0-.49-.1-.67-.29-.17-.2-.26-.44-.26-.72z" />
        </svg>
    );
}

function IconWiSunset(props) {
    return (
        <svg
            viewBox="0 0 30 30"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M2.88 15.47c0-.28.1-.5.3-.68.17-.18.4-.26.68-.26h2.31a.904.904 0 01.93.94c0 .28-.09.52-.27.71-.18.19-.4.29-.66.29h-2.3c-.27 0-.5-.1-.69-.3-.2-.2-.3-.43-.3-.7zm3.29-7.86c0-.28.08-.51.25-.68.2-.2.43-.3.7-.3.29 0 .51.1.68.3l1.62 1.63c.46.44.46.89 0 1.35a.88.88 0 01-.65.28c-.22 0-.44-.09-.68-.28L6.43 8.29a.96.96 0 01-.26-.68zm1.97 13.28c0-.26.1-.49.3-.69.18-.18.41-.27.68-.27h3.22c.11 0 .2.02.28.08l2.35 2.22L17.36 20c.07-.05.17-.08.29-.08h3.3c.27 0 .5.09.69.28.19.19.29.42.29.68 0 .27-.1.5-.29.69-.19.19-.42.29-.69.29h-2.68l-3.14 2.84c-.12.09-.23.09-.33 0l-3.08-2.84h-2.6c-.27 0-.5-.1-.69-.29a.906.906 0 01-.29-.68zm.94-5.42c0 .99.19 1.87.58 2.62.06.11.15.16.27.16h1.87c.08 0 .13-.02.15-.07.02-.05-.01-.11-.07-.18-.59-.74-.89-1.59-.89-2.53 0-1.1.39-2.04 1.18-2.81.79-.77 1.74-1.16 2.85-1.16 1.1 0 2.04.39 2.83 1.16.78.78 1.18 1.71 1.18 2.8 0 .94-.3 1.79-.89 2.53-.07.07-.09.13-.07.18.02.05.07.07.15.07h1.88c.13 0 .21-.05.24-.16.41-.78.62-1.66.62-2.62 0-.79-.16-1.56-.47-2.29s-.74-1.37-1.27-1.9-1.16-.95-1.89-1.27a5.67 5.67 0 00-2.3-.47c-.8 0-1.57.16-2.3.47-.73.32-1.36.74-1.89 1.27s-.95 1.16-1.27 1.9-.49 1.51-.49 2.3zm4.96-8.81V4.33c0-.27.1-.5.29-.69s.42-.29.69-.29c.27 0 .5.1.69.29s.29.42.29.69v2.32c0 .27-.1.5-.29.69-.19.19-.42.29-.69.29-.27 0-.5-.1-.69-.29a.886.886 0 01-.29-.68zm6.27 2.58c0-.28.09-.51.26-.67l1.63-1.63c.16-.2.39-.3.68-.3.27 0 .5.1.68.29.18.19.27.42.27.69 0 .28-.08.51-.25.68l-1.66 1.63c-.23.19-.46.28-.69.28a.87.87 0 01-.66-.28c-.17-.19-.26-.42-.26-.69zm2.59 6.23c0-.27.09-.49.26-.67.17-.18.4-.27.67-.27h2.32c.27 0 .5.09.69.27.19.18.29.4.29.67s-.1.5-.29.7c-.19.2-.42.3-.69.3h-2.32c-.26 0-.48-.1-.66-.29a.998.998 0 01-.27-.71z" />
        </svg>
    );
}

function IconMoon(props) {
    return (
        <svg
            viewBox="0 0 30 30"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M7.91 14.48c0-.96.19-1.87.56-2.75s.88-1.63 1.51-2.26c.63-.63 1.39-1.14 2.27-1.52.88-.38 1.8-.57 2.75-.57h1.14c.16.04.23.14.23.28l.05.88c.04 1.27.49 2.35 1.37 3.24.88.89 1.94 1.37 3.19 1.42l.82.07c.16 0 .24.08.24.23v.98c.01 1.28-.3 2.47-.93 3.56a7.017 7.017 0 01-2.57 2.59c-1.08.63-2.27.95-3.55.95-.97 0-1.9-.19-2.78-.56s-1.63-.88-2.26-1.51a7.084 7.084 0 01-1.5-2.26c-.35-.88-.54-1.8-.54-2.77zm1.83 0c0 .76.15 1.48.45 2.16.3.67.7 1.24 1.19 1.7.49.46 1.05.82 1.69 1.08a4.823 4.823 0 003.7.06 6.24 6.24 0 001.65-.96c.51-.41.94-.93 1.31-1.57.37-.64.6-1.33.71-2.09-1.63-.34-2.94-1.04-3.92-2.1s-1.55-2.3-1.7-3.74c-.96.06-1.82.35-2.61.88-.78.53-1.39 1.2-1.82 2.02-.43.82-.65 1.67-.65 2.56z" />
        </svg>
    );
}
function IconSun(props) {
    return (
        <svg
            fill="currentColor"
            viewBox="-1 -1 18 18"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M8 11a3 3 0 110-6 3 3 0 010 6zm0 1a4 4 0 100-8 4 4 0 000 8zM8 0a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2A.5.5 0 018 0zm0 13a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2A.5.5 0 018 13zm8-5a.5.5 0 01-.5.5h-2a.5.5 0 010-1h2a.5.5 0 01.5.5zM3 8a.5.5 0 01-.5.5h-2a.5.5 0 010-1h2A.5.5 0 013 8zm10.657-5.657a.5.5 0 010 .707l-1.414 1.415a.5.5 0 11-.707-.708l1.414-1.414a.5.5 0 01.707 0zm-9.193 9.193a.5.5 0 010 .707L3.05 13.657a.5.5 0 01-.707-.707l1.414-1.414a.5.5 0 01.707 0zm9.193 2.121a.5.5 0 01-.707 0l-1.414-1.414a.5.5 0 01.707-.707l1.414 1.414a.5.5 0 010 .707zM4.464 4.465a.5.5 0 01-.707 0L2.343 3.05a.5.5 0 11.707-.707l1.414 1.414a.5.5 0 010 .708z" />
        </svg>
    );
}

function IconWiCloud(props) {
    return (
        <svg
            viewBox="0 0 26 26"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M4.61 16.88c0-1.15.36-2.17 1.08-3.07.72-.9 1.63-1.48 2.74-1.73.31-1.37 1.02-2.49 2.11-3.37s2.35-1.32 3.76-1.32c1.38 0 2.61.43 3.69 1.28s1.78 1.95 2.1 3.29h.33c.9 0 1.73.22 2.49.65s1.37 1.03 1.81 1.79c.44.76.67 1.58.67 2.48a4.94 4.94 0 01-2.36 4.25c-.73.45-1.54.69-2.41.72H9.41c-1.34-.06-2.47-.57-3.4-1.53-.93-.95-1.4-2.1-1.4-3.44zm1.71 0c0 .87.3 1.62.9 2.26s1.33.98 2.19 1.03H20.6c.86-.04 1.59-.39 2.19-1.03.61-.64.91-1.4.91-2.26 0-.88-.33-1.63-.98-2.27-.65-.64-1.42-.96-2.32-.96h-1.6c-.11 0-.17-.06-.17-.18l-.07-.57c-.11-1.08-.58-1.99-1.4-2.72-.82-.73-1.77-1.1-2.86-1.1-1.09 0-2.05.37-2.85 1.1-.81.73-1.27 1.64-1.37 2.72l-.08.57c0 .12-.07.18-.2.18h-.53c-.84.1-1.54.46-2.1 1.07s-.85 1.33-.85 2.16z" />
        </svg>
    );
}

function IconWiRain(props) {
    return (
        <svg
            viewBox="0 0 30 30"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M4.64 16.91c0-1.15.36-2.17 1.08-3.07a4.82 4.82 0 012.73-1.73c.31-1.36 1.02-2.48 2.11-3.36s2.34-1.31 3.75-1.31c1.38 0 2.6.43 3.68 1.28 1.08.85 1.78 1.95 2.1 3.29h.32c.89 0 1.72.22 2.48.65s1.37 1.03 1.81 1.78c.44.75.67 1.58.67 2.47 0 .88-.21 1.69-.63 2.44-.42.75-1 1.35-1.73 1.8-.73.45-1.53.69-2.4.71-.13 0-.2-.06-.2-.17v-1.33c0-.12.07-.18.2-.18.85-.04 1.58-.38 2.18-1.02s.9-1.39.9-2.26-.33-1.62-.98-2.26-1.42-.96-2.31-.96h-1.61c-.12 0-.18-.06-.18-.17l-.08-.58a4.076 4.076 0 00-1.39-2.71c-.82-.73-1.76-1.09-2.85-1.09s-2.05.36-2.85 1.09a4.02 4.02 0 00-1.36 2.71l-.07.53c0 .12-.07.19-.2.19l-.53.03c-.83.1-1.53.46-2.1 1.07s-.85 1.33-.85 2.16c0 .87.3 1.62.9 2.26s1.33.98 2.18 1.02c.11 0 .17.06.17.18v1.33c0 .11-.06.17-.17.17-1.34-.06-2.47-.57-3.4-1.53s-1.37-2.1-1.37-3.43zm5.35 6.69c0-.04.01-.11.04-.2l1.63-5.77a.837.837 0 011.02-.56c.24.04.42.17.54.37.12.2.15.42.08.67l-1.63 5.73c-.12.43-.4.64-.82.64-.04 0-.07-.01-.11-.02-.06-.02-.09-.03-.1-.03a.831.831 0 01-.49-.33.895.895 0 01-.16-.5zm2.62 2.81l2.44-8.77c.04-.19.14-.34.3-.44.16-.1.32-.15.49-.15.09 0 .18.01.27.03.22.06.38.19.49.39.11.2.13.41.07.64l-2.43 8.78c-.04.17-.13.31-.29.43-.16.12-.32.18-.51.18-.09 0-.18-.02-.25-.05-.2-.05-.37-.18-.52-.39-.11-.18-.13-.39-.06-.65zm4.13-2.79c0-.04.01-.11.04-.23l1.63-5.77a.83.83 0 01.3-.44c.15-.1.3-.15.46-.15.08 0 .17.01.26.03.21.06.36.16.46.31.1.15.15.31.15.47 0 .03-.01.08-.02.14s-.02.1-.02.12l-1.63 5.73c-.04.19-.13.35-.28.46s-.32.17-.51.17l-.24-.05a.809.809 0 01-.46-.32.916.916 0 01-.14-.47z" />
        </svg>
    );
}

function IconEye(props) {
    return (
        <svg
            viewBox="0 0 1050 1050"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" />
        </svg>
    );
}

function IconWiThermometerExterior(props) {
    return (
        <svg
            viewBox="0 0 30 30"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M9.91 19.56a5.101 5.101 0 012.24-4.22V5.42c0-.8.27-1.48.82-2.03s1.23-.84 2.03-.84c.81 0 1.49.28 2.04.83.55.56.83 1.23.83 2.03v9.92c.71.49 1.25 1.11 1.64 1.84s.58 1.53.58 2.38c0 .92-.23 1.78-.68 2.56s-1.07 1.4-1.85 1.85-1.63.68-2.56.68c-.92 0-1.77-.23-2.55-.68s-1.4-1.07-1.86-1.85-.68-1.63-.68-2.55zm1.76 0c0 .93.33 1.73.98 2.39.65.66 1.44.99 2.36.99.93 0 1.73-.33 2.4-1s1.01-1.46 1.01-2.37c0-.62-.16-1.2-.48-1.73-.32-.53-.76-.94-1.32-1.23l-.28-.14c-.1-.04-.15-.14-.15-.29V5.42c0-.32-.11-.59-.34-.81-.23-.21-.51-.32-.85-.32-.32 0-.6.11-.83.32-.23.21-.34.48-.34.81v10.74c0 .15-.05.25-.14.29l-.27.14c-.55.29-.98.7-1.29 1.23-.31.53-.46 1.1-.46 1.74z" />
        </svg>
    );
}


export {
    cloud, cRain, cElectricStorm,
    cSnow, cWind, sun, sCloud,
    sRain, sSnow, sElectricStorm,
    sWind, moon, mCloud, mRain, mSnow,
    mElectricStorm, mWind, cBroken,
    sShowerRain, mShowerRain,
    IconSquareGithub, IconWiThermometer,
    IconWiRaindrop, IconWind,
    IconEyeFill, IconWiHot,
    IconSpeedometer, IconSearch,
    IconWiSunrise, IconWiSunset,
    IconMoon, IconSun, IconWiRain, IconWiCloud,
    IconEye, IconWiThermometerExterior
}


